module.exports = __webpack_public_path__ + "images/graphic-header-3_5c6c7e4a14b5a449296cf905d7388819.png";